import { memo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import FavoriteModal from "../../srp/FavoriteModal";
import PropertyTags from "../../srp/CardComponents/PropertyTags";
import PriceAndLabel from "../../srp/CardComponents/PriceAndLabel";
import BedBathSqft from "./BedBathSqft";
import TitleHeader from "../../srp/CardComponents/TitleHeader";
import ImageCarousel from "../../srp/CardComponents/ImageCarousel";
import FavoriteButton from "../../srp/CardComponents/FavoriteButton";
import CountdownTimer from "../../srp/CardComponents/CountdownTimer";
import TagIcon from "../../srp/CardComponents/TagIcon";
import CardBidButton from "../../srp/CardBidButton";
import { getEventCategory, trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";
import { getPriceLabel } from "../../srp/CardComponents/priceUtils";
import "./PropertyCard.css";
import { navigateToProperty } from "@/utils/propertyNavigation";

const PropertyCard = ({
  item,
  properties,
  setProperties,
  cardIndex,
  tabName = '',
}) => {
  const { selectedProperty } = useSelector((state) => state.srp);
  const [showModal, setShowModal] = useState(false);
  const [shouldCenterButton, setShouldCenterButton] = useState(false);
  const idPrefix = tabName ? `${tabName?.replaceAll(' ', '-')}-property-cards` : 'property-cards';

  useEffect(() => {
    const priceData = getPriceLabel(item);
    const hasPrice = priceData?.bidTit?.length > 0 && priceData?.BidAmt !== '';
    setShouldCenterButton(!hasPrice);
    // setShouldCenterButton(false);
  }, [item]);

  const onNavigatePDP = (label) => {
    const eventCategory = getEventCategory();

    trackButtonClick({
      eventName:
        eventCategory === "NEW-SRP"
          ? `property_card_click`
          : `recommended_property_click`,
      eventCategory: eventCategory,
      eventSource:
        eventCategory === "NEW-SRP"
          ? `${label ? label : "Property card"} click`
          : `Recomended property detials click`,
      eventLabel:
        eventCategory === "NEW-SRP"
          ? `Property id: ${item?.propertyId} | Location: ${getSrpLocationLabel()}`
          : `Section position: 5 | Property position: ${
              cardIndex + 1
            }`,
      eventParams: { section: label ? label : "property" },
    });
    navigateToProperty(item?.listingUrl || `/property/${item?.listingId || item?.propertyId}`, item?.category, item?.propertyStatus);
  };

  const hasValidCountdown =
    item?.listingType === "AUCN" &&
    (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE") &&
    typeof item?.auctionTimeLeft === "number";

  const tags = {
    firstLook: item?.firstLook === "Y",
    isFcProxyBidEnabled: item?.isFcProxyBidEnabled,
    hotProperty: item?.hotProperty === "Y" || item?.isHotProperty === "Y",
    cwcotFLP:
      item?.category === "SC" &&
      item?.cwcotUpdatesEnabled &&
      item?.cwcotUpdatesValid &&
      "CWCOT FIRST LOOK PROGRAM",
    reserveMet:
      !item?.clientCodeRestrictedFlag &&
      item?.parentBulkPropertyFlag !== "Y" &&
      item?.invrAprvlReqdProp === "N" &&
      (item?.reserveMet === "Y" || item?.reserveMetFlag),
    isNoBuyerPremium: item?.isNoBuyerPremium,
    isPreview: item?.isPreview,
    commercialProperty:
      item?.commercialRetailTag === "Y" || item?.isCommercialProperty === "Y",
    signatureSeller: item?.sellerId && item?.sellerId === "501",
    selfShowing: item?.selfShowingFlag === "Y",
    priceReduced: item?.tagName === "Price Reduced",
  };

  const tagStyle = {
    firstLook: { title: "First Look Period", color: "#08AC12" },
    selfShowing: { title: "Self Showing", color: "#4ab440" },
    hotProperty: { title: "Hot Property", color: "#F25D49" },
    cwcotFLP: { title: "CWCOT FIRST LOOK PROGRAM", color: "#F25D49" },
    reserveMet: { title: "Reserve Met", color: "#F25D49" },
    isNoBuyerPremium: { title: "No Buyer's Premium", color: "#118BF4" },
    isPreview: { title: "Preview Property", color: "#ff7900" },
    commercialProperty: { title: item?.propertyType ? item.propertyType.replace(/_/g, ' ') : 'Commercial', color: "#2D6BA4" },
    isFcProxyBidEnabled: { title: "Proxy Property", color: "#118BF4" },
    signatureSeller: { title: "Hubzu Signature Homes", color: "#63938E" },
    priceReduced: { title: "Price Reduced", color: "#FF7900" },
  };

  return (
    <div
      id={`${idPrefix}-${cardIndex}`}
      className="col-md-6 col-lg-6 take-tour-srp property-card-container"
      key={`card-item-${item?.propertyId}`}
    >
      <div
        id={`${idPrefix}-content-${cardIndex}`}
        className={`feat_property home7 style4 ${
          selectedProperty?.propertyId === item?.propertyId
            ? "selected-highlight"
            : ""
        }`}
      >
        <div id={`${idPrefix}-thumb-${cardIndex}`} className="thumb cursor-pointer mt0 mb0 ml0 mr0 srp-card-border-grid">
          <ImageCarousel
            onClick={() => onNavigatePDP()}
            item={item}
            isGridOrList={false}
            isRecommendedProperties={true}
          />
          <div id={`${idPrefix}-overlay-${cardIndex}`} className="thmb_cntnt" onClick={() => onNavigatePDP()}>
            <PropertyTags {...item} isRecommendedProperties={true} />
            <FavoriteButton
              item={item}
              cardIndex={cardIndex}
              setShowModal={setShowModal}
              isRecommendedProperties={true}
              properties={properties}
              setProperties={setProperties}
            />
            <div id={`${idPrefix}-tags-${cardIndex}`} className="listing_list_style text-align-left p0 m0 property-card-tags">
              {Object.keys(tags).map((tagName, idx) => {
                if (tags[tagName]) {
                  return (
                    <div
                      id={`${idPrefix}-tag-${cardIndex}-${idx}`}
                      className="list-inline-item p0 m0 srp-tooltip property-card-tag-item"
                      key={`tag-item-${tagName}`}
                    >
                      <TagIcon tagName={tagName} />
                      <span className="srp-tooltiptext prop-tooltip">
                        {tagStyle[tagName]?.title}
                        <span className="srp-tooltipArrow"></span>
                      </span>
                    </div>
                  );
                }
              })}
              {item?.category === "COMMERCIAL" &&
                item?.propertyStatus === "PACT" && (
                  <span
                    id={`${idPrefix}-preview-tag-${cardIndex}`}
                    className={`text-capitalize ${
                      !(tags?.length > 0)
                        ? "preview-tag"
                        : "preview-tag-single"
                    }`}
                  >
                    PREVIEW
                  </span>
                )}
            </div>
          </div>
        </div>

        <FavoriteModal
          showModal={showModal}
          setShowModal={setShowModal}
          handleClose={() => setShowModal(false)}
          item={item}
        />

        <div id={`${idPrefix}-details-${cardIndex}`} className="details">
          <div id={`${idPrefix}-info-${cardIndex}`} className="tc_content pt0 property-card-content">
            <div className="row">
              <div className="col-md-12">
                <TitleHeader
                  item={item}
                  isGridOrList={false}
                  onNavigatePDP={() => onNavigatePDP()}
                />
                {item?.commercialRetailTag === "Y" && item?.shortDescription ? (
                  <div id={`${idPrefix}-description-${cardIndex}`}>
                    <span className="card-item-short-description number_of_line_one">
                      {item?.shortDescription}
                    </span>
                  </div>
                ) : item?.commercialRetailTag === "Y" ||
                  item?.isCommercialProperty === "Y" ? (
                  <div className="pt20" />
                ) : (
                  <div id={`${idPrefix}-bedbath-${cardIndex}`} className="property-card-bedbath">
                    <BedBathSqft item={item} />
                  </div>
                )}

                {item?.category === "COMMERCIAL" &&
                  item?.propertyStatus === "PACT" && (
                    <div id={`${idPrefix}-commercial-timer-${cardIndex}`} className="justify-content-center">
                      <div>
                        <span className="auctionTimeLeft_heading">
                          Time Until Auction Begins:
                        </span>
                      </div>
                      <div className="d-flex justify-content-center">
                        <CountdownTimer
                          until={item?.auctionTimeLeft / 1000}
                          isRecommendedProperties={true}
                        />
                      </div>
                    </div>
                  )}

                {item?.category !== "FORECLOSURE" &&
                  item?.propertyStatus === "" &&
                  item?.isPreview && (
                    <div id={`${idPrefix}-preview-desc-${cardIndex}`} className="cursor-pointer property-card-preview">
                      <span className="preview-prop-desc number_of_line_two">
                        Hubzu does not guarantee preview properties will be
                        available for bids or offers.
                      </span>
                    </div>
                  )}
                {item?.category === "FORECLOSURE" &&
                (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE") &&
                item?.fcOnlineFlag === "Y" ? (
                  hasValidCountdown && (
                    <div id={`${idPrefix}-timer-${cardIndex}`} className="d-flex justify-content-center mt10">
                      <CountdownTimer
                        until={item?.auctionTimeLeft / 1000}
                        isRecommendedProperties={true}
                      />
                    </div>
                  )
                ) : item?.category === "FORECLOSURE" &&
                  item?.fcOnlineFlag === "Y" &&
                  (item?.propertyStatus === "WFA" ||
                    item?.propertyStatus === "POSTPONED") ? (
                  <ul
                    id={`${idPrefix}-status-${cardIndex}`}
                    className="prop_details pb10 pt15"
                  >
                    {item?.propertyStatus === "WFA" ? (
                      <li className="list-inline-item">
                        <div className="card-item-head">
                          Scheduled{" "}
                          {item?.auctionDuration
                            ? `for ${item?.auctionDuration}`
                            : ""}
                        </div>
                      </li>
                    ) : (
                      <li className="list-inline-item">
                        <div className="card-item-head">
                          Auction Event Postponed{" "}
                          {item?.auctionDuration
                            ? `to ${item?.auctionDuration}`
                            : ""}
                        </div>
                      </li>
                    )}
                  </ul>
                ) : item?.category === "FORECLOSURE" &&
                  item?.fcOnlineFlag === "Y" &&
                  item?.propertyStatus &&
                  item?.propertyStatus === "WLST" &&
                  item?.listingStatus &&
                  item?.listingStatus === "Closed" &&
                  item?.listingDetailStatus &&
                  item?.listingDetailStatus === "CANCELLED" ? (
                  <div
                    id={`${idPrefix}-status-${cardIndex}`}
                    className="cursor-pointer"
                    style={{ marginBottom: -20, marginTop: 20 }}
                  >
                    <span className="card-item-head number_of_line_one">
                      Auction Event Cancelled
                    </span>
                  </div>
                ) : item?.category === "FORECLOSURE" &&
                  item?.fcOnlineFlag === "Y" ? (
                  <div
                    id={`${idPrefix}-status-${cardIndex}`}
                    className="cursor-pointer"
                    style={{ marginBottom: -20, marginTop: 20 }}
                  >
                    <span className="card-item-head number_of_line_one">
                      Auction Event Ended
                    </span>
                  </div>
                ) : item?.category === "FORECLOSURE" ? (
                  <>
                    {item?.category === "FORECLOSURE" &&
                    (item?.propertyStatus === "SCHEDULED" ||
                      item?.propertyStatus === "CLEAR_TO_SALE") ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          {item?.propertyStatus === "SCHEDULED"
                            ? "Scheduled"
                            : "Cleared to sell"}{" "}
                          {item?.event
                            ? `for ${
                                item?.event.eventDate +
                                ", " +
                                item?.event.eventTime +
                                " local"
                              }`
                            : ""}
                        </span>
                      </div>
                    ) : item?.category === "FORECLOSURE" &&
                      item?.propertyStatus === "POSTPONED" ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          Postponed
                        </span>
                      </div>
                    ) : item?.category === "FORECLOSURE" &&
                      item?.propertyStatus === "AUCTION_EVENT_ENDED" ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          Auction Ended
                        </span>
                      </div>
                    ) : item?.category === "FORECLOSURE" &&
                      item?.propertyStatus === "EXPIRED" ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          Auction Ended
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                ) : item?.listingType === "TRNL" &&
                  item?.category != "FORECLOSURE" ? (
                  <div
                    id={`${idPrefix}-status-${cardIndex}`}
                    className="cursor-pointer"
                    style={{ marginBottom: -20, marginTop: 20 }}
                  >
                    <span className="card-item-head number_of_line_one">
                      Traditional Sale
                    </span>
                  </div>
                ) : item?.category != "FORECLOSURE" &&
                  (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE")? (
                  hasValidCountdown && (
                    <div id={`${idPrefix}-timer-${cardIndex}`} className="d-flex justify-content-center mt10">
                      <CountdownTimer
                        until={item?.auctionTimeLeft / 1000}
                        isRecommendedProperties={true}
                      />
                    </div>
                  )
                ) : item?.isPreview != true ? (
                  <>
                    {item?.category != "FORECLOSURE" &&
                    item?.propertyStatus === "WFA" ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          Scheduled{" "}
                          {item?.auctionDuration
                            ? `for ${item?.auctionDuration}`
                            : ""}
                        </span>
                      </div>
                    ) : item?.tagName === "UnderContract" ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          Auction Ended
                        </span>
                      </div>
                    ) : item?.tagName === "UnderReview" ? (
                      <div
                        id={`${idPrefix}-status-${cardIndex}`}
                        className="cursor-pointer"
                        style={{ marginBottom: -20, marginTop: 20 }}
                      >
                        <span className="card-item-head number_of_line_one">
                          Under Review
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {!hasValidCountdown &&
              !(
                item?.propertyStatus === "WFA" && item?.auctionDuration != null
              ) &&
              (item?.listingType === "TRNL" ||
              (item?.commercialRetailTag === "Y" && item?.shortDescription) ? (
                <div className="min_auction_height"></div>
              ) : (
                <div className="min_head_title_height" />
              ))}
          </div>
          <div id={`${idPrefix}-footer-${cardIndex}`} className="fp_footer srp-card-footer">
            {!shouldCenterButton  && <PriceAndLabel item={item} />}
            <div id={`${idPrefix}-bid-btn-${cardIndex}`} className={`home-property-card-bid-button ${shouldCenterButton ? 'd-flex justify-content-center' : ''}`}>
              <CardBidButton
                isRecommendedProperties={true}
                item={item}
                cardIndex={cardIndex}
                style={shouldCenterButton ? { width: '90%' } : {}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PropertyCard);